import { Box, Typography } from '@mui/material';
import { BloomStats } from '../PerformanceDrawer/performanceDrawerData';
import { pxToRem } from '@geneo2-web/shared-ui';
import { ProgressBar } from '../ProgressBar';

export const LevelRow = ({
  label,
  correct,
  total,
  color,
  bgColor,
}: {
  label: string;
  correct: number;
  total: number;
  color: string;
  bgColor: string;
}) => {
  const percent = total > 0 ? (correct / total) * 100 : 0;

  return (
    <Box display="flex" alignItems="center" gap={pxToRem(10)}>
      {/* TAG */}
      <Box
        sx={{
          minWidth: pxToRem(70),
          textAlign: 'center',
          px: pxToRem(8),
          py: pxToRem(3),
          borderRadius: pxToRem(7),
          background: bgColor,
        }}
      >
        <Typography
          sx={{
            fontSize: pxToRem(11),
            fontWeight: 700,
            color,
            textTransform: 'uppercase',
          }}
        >
          {label}
        </Typography>
      </Box>

      {/* BAR */}
      <Box flex={1}>
        <ProgressBar valuePercent={percent} height={6} color={color} />
      </Box>

      {/* STATS */}
      <Typography
        sx={{
          fontSize: pxToRem(11),
          fontWeight: 700,
          color: '#64748b',
          minWidth: pxToRem(50),
          textAlign: 'right',
        }}
      >
        <Box component="span" color={color}>
          {correct}
        </Box>
        /{total}
      </Typography>
    </Box>
  );
};
